import { createSlice } from "@reduxjs/toolkit";
import { appStorageKey, tenant } from "../utils/global";

// Get stored branch from localStorage or use default
const getStoredBranch = () => {
    const storedBranch = localStorage.getItem(appStorageKey('selectedBranch'));
    if (storedBranch) {
        return JSON.parse(storedBranch);
    }
    const t = tenant();
    const firstCompany = t?.companies?.[0];
    const firstBranch = firstCompany?.branches?.[0];
    const langFromI18n = String(localStorage.getItem('i18nextLng') || '').toLowerCase().startsWith('ar') ? 'ar' : 'en';
    const defaultLangFromSettings =
      firstCompany?.settings?.generalSettings?.find?.((s) => s?.name === 'DEFAULT_LANG')?.value ||
      firstCompany?.settings?.generalSettings?.find?.((s) => s?.settingName === 'DEFAULT_LANG')?.value;
    const desiredLang = (defaultLangFromSettings || langFromI18n || 'en').toLowerCase().startsWith('ar') ? 'ar' : 'en';
    const branchNameText =
      firstBranch?.name?.find?.((n) => n?.lang === desiredLang)?.text ||
      firstBranch?.name?.find?.((n) => n?.lang === 'ar')?.text ||
      firstBranch?.name?.[0]?.text ||
      (desiredLang === 'ar' ? 'الفرع' : 'Select a Branch');
    return {
        name: branchNameText,
        value: firstBranch?._id,
    };
};

const initialState = getStoredBranch();

const currentBranchSlice = createSlice({
    name: 'currentBranch',
    initialState,
    reducers: {
        setCurrentBranch:(state,action)=> {
            state.name = action.payload.name;
            state.value = action.payload.value;
            state.updatedAt = Date.now();
            localStorage.setItem(appStorageKey('selectedBranch'), JSON.stringify({
                name: action.payload.name,
                value: action.payload.value,
                updatedAt: state.updatedAt
            }));
        }
    }
});

export const {setCurrentBranch} = currentBranchSlice.actions;
export default currentBranchSlice.reducer
